export enum RootStateNavigator {
  splash = "SPLASH",
  auth = "AUTH",
  onboarding = "ONBOARDING",
  partners = "PARTNERS",
}
